import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getFloor({ commit }, buildingUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.getFloor(
        buildingUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  storeFloor({ commit }, floorData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.storeFloor(
        floorData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  updateFloor({ commit }, floorData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.updateFloor(
        floorData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteFloor({ commit }, floorUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFloor(
        floorUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteFloors({ commit }, floorsList) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFloors(
        floorsList,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  getColumn({ commit }, columnUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.getColumn(
        columnUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  storeColumn({ commit }, columnData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.storeColumn(
        columnData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  updataColumn({ commit }, columnData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.updateFloor(
        columnData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteColumn({ commit }, columnUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFloor(
        columnUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteColumns({ commit }, columnsList) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteColumns(
        columnsList,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  getFloorbox({ commit }, floorboxUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.getFloorbox(
        floorboxUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  storeFloorbox({ commit }, floorboxData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.storeFloorbox(
        floorboxData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  updateFloorbox({ commit }, floorboxData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFloor(
        floorboxData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteFloorbox({ commit }, floorboxUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFloorbox(
        floorboxUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteFloorboxes({ commit }, floorboxesList) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFloorboxes(
        floorboxesList,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  getFraction({ commit }, fractionUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.getFraction(
        fractionUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response)
        }
      )
    })
  },

  storeFraction({ commit }, fractionData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.storeFraction(
        fractionData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  updateFraction({ commit }, fractionData) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.updateFraction(
        fractionData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteFraction({ commit }, fractionUuid) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFraction(
        fractionUuid,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  },

  deleteFractions({ commit }, fractionsList) {
    return new Promise((resolve, reject) => {
      API.buildingVerticalPlanning.deleteFractions(
        fractionsList,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      )
    })
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Home/buildingVerticalPlanning.js